import { render, staticRenderFns } from "./list.vue?vue&type=template&id=e8ad3656&scoped=true&lang=pug&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=e8ad3656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ad3656",
  null
  
)

/* custom blocks */
import block0 from "./list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteBlogAuthor: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/site/blog/author.vue').default,SiteBlogCategories: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/site/blog/categories.vue').default,SiteBlogPreview: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/site/blog/preview.vue').default,WidgetsPagination: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/pagination.vue').default})
